import { useCallback, useEffect, useState } from "react";
import { Area } from "../models/Area";
import PlotAPI from "../plotAPI";

interface useMapAreasProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useMapAreas = ({ projects, projectInfo }: useMapAreasProps) => {
    const [mapAreasByProject, setMapAreasByProject] = useState<{ unique_token: string; areas: Area[] }[]>([]);

    const refreshMapAreasByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectAreas(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((areas) => {
                    return {
                        unique_token: project.unique_token,
                        areas: areas,
                    };
                })
            )
        ).then((areas) => {
            setMapAreasByProject(areas);
        });
    }, [projects]);

    useEffect(() => {
        refreshMapAreasByProject();
    }, [projects, refreshMapAreasByProject]);

    const mapAreasForProject = (projectId: string | number): Area[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return mapAreasByProject.find((project) => project.unique_token === projectToken)?.areas || [];
    };

    return {
        mapAreasByProject,
        mapAreasForProject,
        refreshMapAreasByProject,
    };
};

export default useMapAreas;
